const t = {
  name: "SkipDown",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.00025 17.0001L17.0002 17.0001L17.0002 15.0001L7.00024 15.0001L7.00025 17.0001Z" fill="currentColor"/>
<path d="M12.0002 10.5859L8.00015 6.58594L6.58594 8.00015L12.0002 13.4144L17.4144 8.00015L16.0002 6.58594L12.0002 10.5859Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as SkipDown
};
